import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';
import { Button } from '../ui/button';

export const DeleteConfirmDialog = ({
  open,
  onOpenChange,
  type,
  onConfirm,
  loading
}) => {
  const title = type === 'draft' ? 'Delete Draft' : 'Delete Silica Load';
  const description = type === 'draft' 
    ? 'Are you sure you want to delete this draft? This action cannot be undone.'
    : 'Are you sure you want to delete this silica load? This action cannot be undone.';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-xl">Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm} 
            className="bg-red-600 hover:bg-red-700 rounded-xl"
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const ErrorDialog = ({
  open,
  onOpenChange,
  message,
  fieldName,
  onScrollToField
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-red-600">Validation Error</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-600">
            <span className="font-semibold">{fieldName}:</span> {message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction 
            onClick={onScrollToField} 
            className="rounded-xl bg-slate-800 hover:bg-slate-700"
          >
            Go to Field
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const DraftSavedDialog = ({
  open,
  onOpenChange,
  onViewDrafts,
  onDiscard
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-amber-600 flex items-center gap-2">
            Save as Draft?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-slate-600">
            Your silica load has been saved as a draft. You can access it from the Drafts button to continue later.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col sm:flex-row gap-2">
          {onDiscard && (
            <Button 
              variant="ghost"
              onClick={onDiscard}
              className="rounded-xl text-red-600 hover:text-red-700 hover:bg-red-50"
            >
              Discard Draft
            </Button>
          )}
          {onViewDrafts && (
            <Button 
              variant="outline"
              onClick={onViewDrafts}
              className="rounded-xl"
            >
              View Drafts
            </Button>
          )}
          <AlertDialogAction 
            onClick={() => onOpenChange(false)} 
            className="rounded-xl bg-slate-800 hover:bg-slate-700"
          >
            OK
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
